<template>
  <div>
    <c-table
      ref="table"
      title="사용자매뉴얼 목록"
      :columns="grid.columns"
      :data="grid.data"
      rowKey="userManualId"
      :gridHeight="height"
      :columnSetting="false"
      :usePaging="false"
      :isExcelDown="false"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template v-slot:table-button>
        <q-btn-group outline>
          <c-btn
            v-if="editable && !popupParam.isPopup"
            label="등록"
            icon="add"
            @btnClicked="linkClick"
          />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props }">
        <q-icon
          class="cursor-pointer"
          name="description"
          size="sm"
          color="blue-6"
          @click="iconClick(props.row)"
        />
      </template>
    </c-table>
    <c-dialog :param="popupOptions" />
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "userManual",
  props: {
    popupParam: {
      type: Object,
      default() {
        return {
          isPopup: false,
        };
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: "revisionNum",
            field: "revisionNum",
            label: "Rev.",
            align: "center",
            style: "width:50px",
            sortable: true,
          },
          {
            name: "taskName",
            field: "taskName",
            label: "업무명",
            align: "left",
            style: "width:150px",
            type: "link",
          },
          {
            name: "custom",
            field: "custom",
            label: "바로보기",
            align: "center",
            sortable: false,
            style: "width:50px",
            type: "custom",
          },
          {
            name: "revisionContent",
            field: "revisionContent",
            label: "개정사유",
            align: "left",
            style: "width:200px",
          },
          {
            name: "regUserName",
            field: "regUserName",
            label: "개정자",
            align: "center",
            style: "width:80px",
          },
          {
            name: "regDtStrTime",
            field: "regDtStrTime",
            label: "개정일시",
            align: "center",
            style: "width:100px",
          },
        ],
        data: [],
      },
      listUrl: "",
      editable: true,
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    height() {
      return this.popupParam.isPopup ? "700px" : "";
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // code setting
      this.listUrl = selectConfig.um.userManual.list.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    linkClick(row) {
      this.popupOptions.title = "사용자매뉴얼 상세";
      this.popupOptions.param = {
        userManualId: row ? row.userManualId : null,
      };
      this.popupOptions.target = () => import(`${"./userManualDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = false;
      this.popupOptions.width = "80%";
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    iconClick(row) {
      if (row.pdfDownPath === "" || row.pdfDownPath === null) {
        window.getApp.$emit("ALERT", {
          title: "안내",
          message: "첨부된 파일이 없습니다.",
          type: "warning", // success / info / warning / error
        });
      } else {
        this.popupOptions.title = "사용자매뉴얼 (" + row.taskName + ")";
        this.popupOptions.param = {
          userManualId: row ? row.userManualId : null,
        };
        this.popupOptions.target = () => import(`${"./userManualPage.vue"}`);
        this.popupOptions.visible = true;
        this.popupOptions.isFull = false;
        this.popupOptions.width = "80%";
        this.popupOptions.closeCallback = this.closePopup;
      }
    },
  },
};
</script>
